import { render, staticRenderFns } from "./BudgetShow.vue?vue&type=template&id=5c5f8b98"
import script from "./BudgetShow.vue?vue&type=script&lang=ts"
export * from "./BudgetShow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports